import styled from "styled-components";

export const OverlayContainerSC = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
  top: 0;
  z-index: 10;
`;
